import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostBinding
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

type PopoverType =
  | "note"
  | "oversale"
  | "status-diff"
  | "inventory-diff"
  | "note-edit"
  | "house-auto-managed"
  | "type-auto-managed"
  | 'dirty-house';

@Component({
  selector: "host-auto-popover",
  templateUrl: "./auto-popover.component.html",
  styleUrls: ["./auto-popover.component.scss"]
})
export class AutoPopoverComponent implements OnInit {
  @Input() type: PopoverType = "note";
  @Input() hostStyle;
  @Input() noteText = "";

  @Input() statusDiffList = {};

  @Input() inventoryDiffList = {};
  @Input() oversaleMap = [];

  @Input() cleanStatus; // 1, 3

  @Output() onClickEditNote = new EventEmitter();
  @Output() onClickEditOversale = new EventEmitter();
  @Output() onClickEditHouseAutoManaged = new EventEmitter();
  @Output() onClickEditTypeAutoManaged = new EventEmitter();
  @Output() onClickConfirmEditNote = new EventEmitter();
  @Output() onClickCancelEditNote = new EventEmitter();
  @Output() onClickArrangeClean = new EventEmitter();
  @Output() onClickUpdateCleanStatus = new EventEmitter();
  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() { }
}
